import {loadProfile} from 'Utils/jwtUtil';
import auth from './auth';
import host from './host';
import myOrder from './myOrder';
import userCenter from './userCenter';
import {T} from 'Actions/translate';

function goToLogin(role) {
    window.clearTimeout(window.goToLoginTimer);
    window.goToLoginTimer = window.setTimeout(() => {
        switch (role) {
            case 1:
            case 2:
            case 3:
                window.location.href = `${window.location.origin}/${process.env.http_env}/adminLogin`;
                break;
            case 0:
                window.location.href = `${window.location.origin}/${process.env.http_env}/adminLogin`;
                break;
            default:
                window.location.href = `${window.location.origin}/${process.env.http_env}/login`;
        }
    }, 100);
}

export default function (errorMsg) {
    let obj = {
        auth,
        host,
        myOrder,
        userCenter,
    };

    switch (errorMsg) {
        case 'unauthorized':
            goToLogin(loadProfile().roleType);
            return T('notification_login_again');
        default:
            break;
    }

    let list = Object.values(obj);

    for (let i = 0; i < list.length; i++) {
        let msg = list[i](...arguments);
        if (msg) return msg;
    }
}
